import axios from "axios";
import { getApiBaseUrl } from "../../config";

const apiPrefix = getApiBaseUrl("auth");

export const getUserData = async (token, reqBody) => {
  return await axios.post(`${apiPrefix}/api/v1/user-list`, reqBody, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteUser = async (token, reqBody) => {
  return await axios.post(`${apiPrefix}/api/v1/delete-user`, reqBody, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getUserInfo = async (token, reqBody) => {
  return await axios.post(`${apiPrefix}/api/v1/admin-user-info`, reqBody, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const saveUserData = async (token, formData) => {
  return await axios.post(`${apiPrefix}/api/v1/create-user`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const setAdminUserNewPasswordApi = async (formData) => {
  return await axios.post(`${apiPrefix}/api/v1/user-password-reset`, formData);
};

export const changePasswordApi = async (token, formData) => {
  return await axios.post(`${apiPrefix}/api/v1/change-password`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const checkResetPwdLinkExist = async (formData) => {
  return await axios.post(`${apiPrefix}/api/v1/check-user-exists`, formData);
};
